import { apiClient } from '../utils/apiClient';

/**
 * REST surface for encrypted in-chat secret sharing (CONTRACTS.md §3).
 * Only PUBLIC key material moves through here — ciphertext rides inside the
 * chat message itself (chatService.sendMessage with kind "secret"), and
 * private keys never leave utils/vaultShareCrypto.js.
 */

/** PUT /me/e2e_key — publish my public JWK (JSON string, ≤1 KB server-side). */
export async function putMyE2eKey(publicJwkString) {
  const res = await apiClient.put('/me/e2e_key', { public_key: publicJwkString });
  return res.data;
}

/**
 * GET /chat/channels/{id}/e2e_keys — member-only map of
 * userId → public JWK string | null (null = that member never published one).
 */
export async function getChannelE2eKeys(channelId) {
  const res = await apiClient.get(`/chat/channels/${channelId}/e2e_keys`);
  return res.data.keys || {};
}

const vaultShareService = { putMyE2eKey, getChannelE2eKeys };
export default vaultShareService;
